import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appOnlynumber]'
})
export class OnlynumberDirective {
  
  @Input() canApply: boolean = true;
  @Input() canApplyDecimal: boolean = false;
  @Input() allowNegative: boolean = false; // allowing negative numbers

  private navigationKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
    'Clear',
    'Copy',
    'Paste'
  ];

  constructor(public el: ElementRef, private control: NgControl) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    const currentValue: string = this.el.nativeElement.value || '';
    if (!this.canApply) { return; }

    // Allow navigation and command keys
    if (this.navigationKeys.includes(e.key) || this.isCommandKey(e)) {
      return;
    }

    const isMinusKey = e.key === '-' && currentValue.length === 0; // Allow minus only at the start
    const isDecimalKey = e.key === '.'; // Decimal point
    const isValidNumberKey = this.isNumberKey(e);

    // Ensure only valid input
    if (
      (e.shiftKey || !isValidNumberKey) && 
      !(this.allowNegative && isMinusKey) && 
      !(this.canApplyDecimal && isDecimalKey && !this.hasDecimal(currentValue))
    ) {
      e.preventDefault();
    }
  }

  private isCommandKey(e: KeyboardEvent): boolean {
    return (e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key);
  }

  private isNumberKey(e: KeyboardEvent): boolean {
    return (e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105);
  }

  private hasDecimal(value: string): boolean {
    return value.includes('.');
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    if (!this.canApply) { return; }
    event.preventDefault();
    const pastedInput: string = event.clipboardData!.getData('text/plain')
      .replace(/[^\d.-]/g, ''); // Allow digits, minus, and decimal
    document.execCommand('insertText', false, pastedInput);
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    if (!this.canApply) { return; }
    event.preventDefault();
    const textData = event.dataTransfer!.getData('text').replace(/[^\d.-]/g, '');
    this.el.nativeElement.focus();
    document.execCommand('insertText', false, textData);
  }
}
